import {DataTableCellProps} from "@variocube/app-ui";
import React from "react";
import {Booking} from "../../api";
import {BookingLinkChip} from "./BookingChip";

export function BookingCell({row: booking}: DataTableCellProps<Booking>) {
	return <BookingLinkChip booking={booking} />;
}
